export default function ProTag() {
   return (
      <>
         <div
            style={{
               background: 'linear-gradient(53deg, #5015F6 2.33%, #9A88F4 100%)',
               padding: '4px 8px',
               borderRadius: '20px',
               justifyContent: 'center',
               alignItems: 'center',
               color: '#FFF',
               fontSize: '8px',
               fontStyle: 'normal',
               fontWeight: '600',
               textAlign: 'center',
               leadingTrim: 'both',
               textEdge: 'cap',
               width: 'fit-content',
               maxWidth: '40px',
            }}
         >
            PRO
         </div>
      </>
   );
}
